// π ----
// :: MODULES BOOTSTRAP ---------------------------::
// ____

/* :: Imports
---------------------------------- */
// import Vue from 'vue';

import animate from './partials/components/animations';
import guest from './partials/components/guest';
import hero from './partials/modules/hero';

//This is just testing data for dev purposes
import testData from './data/test_data';
window.testData = testData;

export default {
    init() {
        animate.init();
    },
    finalize() {
        hero.finalize();
        guest.finalize();
    }
};
